import { IFavoriteProfessionalApi } from '~/domain/FavoriteProfessionals/favoriteProfessionalsTypes';
import { getAuthHeaders, tempMeeApi } from '~/services/api';

export interface IGetFavoriteProfessionalsParams {
  officeId: string;
  jobId?: string;
  date?: string;
}

async function getFavoriteProfessionals({
  officeId,
  jobId,
  date,
}: IGetFavoriteProfessionalsParams): Promise<IFavoriteProfessionalApi[]> {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get<IFavoriteProfessionalApi[]>(`/favorite-professionals`, {
    headers: { ...headers, 'x-office': officeId ?? undefined },
    params: {
      jobId: jobId ?? undefined,
      date: date ?? undefined,
    },
  });

  return response.data;
}

export const favoriteProfessionalsApi = {
  getFavoriteProfessionals,
};
